<template>
  <div class="card-alert">
    <div class="card-alert__left-wrap">
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path d="M1 21H23L12 2L1 21ZM13 18H11V16H13V18ZM13 14H11V10H13V14Z" fill="url(#paint0_linear)" />
        <defs>
          <linearGradient
            id="paint0_linear"
            x1="12"
            y1="2"
            x2="12"
            y2="21"
            gradientUnits="userSpaceOnUse"
          >
            <stop stop-color="#FF2828" />
            <stop offset="1" stop-color="#D20000" />
          </linearGradient>
        </defs>
      </svg>
      <span>{{ $t('tariffExpired') }}</span>
    </div>
    <VBtn
      class="card-alert__btn"
      @click="runRenew"
      color="success"
    >
      {{ $t('renewTariff') }}
    </VBtn>
  </div>
</template>

<script>
import { computed } from '@vue/composition-api';
import useAccount from '@/compositions/accounting/useAccount';
import useCompany from '@/compositions/useCompany';
import { companyPartnerCodeType } from '@/enums';

export default {
  name: 'InactiveTariffAlert',
  setup(_, { root: { $router } }) {
    const { account } = useAccount();
    const { company } = useCompany();

    const actionHref = computed(() => {
      switch (company.value?.companyPartnerCode) {
        case companyPartnerCodeType.ROSTELECOM: {
          return 'https://hrservice.rt.ru/pay';
        }
        default: {
          return '#';
        }
      }
    });

    function runRenew() {
      if (company.value?.companyPartnerCode) {
        window.location.href = actionHref.value;
        return;
      }

      if (!account.value?.plan?.id) {
        return;
      }

      $router.push({
        name: 'order',
        params: { type: 'plan', id: account.value.plan.id },
        query: { renew: true },
      });
    }

    return {
      runRenew,
    };
  },
};
</script>

<style lang="scss" scoped>
.card-alert {
  display: flex;
  align-items: center;
  justify-content: space-between;
  background: rgba(234, 13, 13, 0.05);
  border: 1px solid rgba(234, 13, 13, 0.2);
  border-radius: 0.375rem;
  font-weight: 400;
  font-size: 0.875rem;
  line-height: 1.14;
  color: #EA0D0D;
  padding: 0.875rem 1.125rem;
  margin: 1rem 0 0 0;
  &__left-wrap {
    display: flex;
    align-items: center;
  }
  svg {
    margin-right: 0.625rem;
  }
  &__btn {
    min-width: 10.625rem;
    background: #1FC57F;
    box-shadow: 0 0.125rem 0.25rem rgba(0, 0, 0, 0.24);
    padding: 0.5rem 1rem;
    border-radius: 0.25rem;
    justify-self: right;
    font-weight: 500;
    font-size: 0.875rem;
    line-height: 1.21;
    letter-spacing: 0.02em;
    color: #FFFFFF;
    margin-left: 1.5rem;
  }
}
@media #{map-get($display-breakpoints, 'md-and-down')} {
  .card-alert {
    padding: 0.75rem 1rem;
    margin: 1rem 0 0.5rem 0;
    line-height: 1.33;
    svg {
      width: 1.375rem;
      min-width: 1.375rem;
      margin-right: 0.75rem;
    }
    &__btn {
      margin-left: 3rem;
    }
  }
}
@media #{map-get($display-breakpoints, 'xs-only')} {
  .card-alert {
    display: block;
    font-size: 0.8125rem;
    padding: 0.75rem 0.875rem;
    svg {
      width: 1.25rem;
      min-width: 1.25rem;
      margin-right: 0.5rem;
    }
    &__btn {
      display: block;
      font-size: 0.75rem;
      margin: 0.75rem auto 0 auto;
    }
  }
}
</style>

<i18n lang="yml" locale="ru">
tariffExpired: Тариф закончился
renewTariff: Продлить тариф
</i18n>
<i18n lang="yml" locale="en">
tariffExpired: Tariff has expired
renewTariff: Renew tariff
</i18n>